import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "card mb-5 mb-xl-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "在架款数")
], -1)
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_10 = { class: "table-responsive" }

import {MenuComponent} from "@/assets/ts/components";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import ApiService from "@/core/services/ApiService";
import {ElMessage} from 'element-plus';
import Filter from "./components/CategoryFilter.vue";
import Detail from "./components/Detail.vue";
import {renderThousands} from "@/utils";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const apiUrl = 'report/newin';
const tableData = ref<any[]>([]);
const filters = reactive({
});
const indicator = ref<any[]>([]);
const showIndicator = ref<any[]>([
  'c_sale_goods_num_rate', // 动销率
  'c_imp_onsale_goods_num', // 款均曝光量
  // 'c_gmv_onsale_goods_num', // 款均价值
  // 'c_click_imp_rate', // 曝光点击率
]);
const chartData = ref<any>({});
const loading = ref<boolean>(false);
const onSaleData = ref<any[]>([]);

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("report.product.categoryNew", ["report.product.name", "report.product.categoryName"]);

  ApiService.get('report/category/indicator', {report_id: 3}).then(({data}) => {
    if (data.length < 1) {
      ElMessage.error('基础数据不足，请与管理员联系！');
    } else {
      indicator.value = [];
      for (let i of data) {
        if (i.is_display == 1 && i.data_type != 1) {
          indicator.value.push(i);
        }
      }
    }
  });
});

// 搜索动作
const searchAction = (filter) => {
  loading.value = true;
  for (let k in filter) {
    filters[k] = filter[k];
  }
  ApiService.get(apiUrl + '/summary', filters).then(({data}) => {
    tableData.value = data;
    for (let i in showIndicator.value) {
      changeTable(i, showIndicator.value[i]);
    }
    loading.value = false;
  });

  ApiService.get(apiUrl + '/summary/?dimension=goods_sale_type', filters).then(({data}) => {
    let obj = {};
    let on_sale_obj = {};
    let obj_amount = {'第1周': 0, '第2周': 0, '第3周': 0, '第4周': 0, '第5周': 0, '第6周': 0, '第7周': 0, '第8周': 0};  // 每周总计
    let amount = 0;  // 全局总计
    for (let d of data) {
      // 处理外层表格
      let on_sale_ww = d['on_sale_ww'];
      if (!obj[on_sale_ww]) {
        obj[on_sale_ww] = {
          'on_sale_ww': on_sale_ww,
          '第1周': 0,
          '第2周': 0,
          '第3周': 0,
          '第4周': 0,
          '第5周': 0,
          '第6周': 0,
          '第7周': 0,
          '第8周': 0,
          'amount': 0,
          'on_sale_data': [],
        };
      }
      obj[on_sale_ww][d['on_shelf_ww']] += Number(d['end_onsale_goods_num']);
      obj[on_sale_ww]['amount'] += Number(d['end_onsale_goods_num']);
      obj_amount[d['on_shelf_ww']] += Number(d['end_onsale_goods_num']);
      amount += Number(d['end_onsale_goods_num']);
      // 处理内层表格
      if (!on_sale_obj[on_sale_ww]) on_sale_obj[on_sale_ww] = {};
      let goods_sale_type = d['goods_sale_type'];
      if (!on_sale_obj[on_sale_ww][goods_sale_type]) {
        on_sale_obj[on_sale_ww][goods_sale_type] = {
          'goods_sale_type': goods_sale_type,
          '第1周': 0,
          '第2周': 0,
          '第3周': 0,
          '第4周': 0,
          '第5周': 0,
          '第6周': 0,
          '第7周': 0,
          '第8周': 0,
          'amount': 0,
        }
      }
      on_sale_obj[on_sale_ww][goods_sale_type][d['on_shelf_ww']] += Number(d['end_onsale_goods_num']);
      on_sale_obj[on_sale_ww][goods_sale_type]['amount'] += Number(d['end_onsale_goods_num']);
    }
    // 内外层合在一起，并转换为百分数
    for (let w in obj) {
      for (let goods_sale_type in on_sale_obj[w]) {
        let o = on_sale_obj[w][goods_sale_type];
        for (let i = 1; i<= 8; i ++) {
          o['第' + i + '周'] = o['第' + i + '周'] == 0 ? '' : (o['第' + i + '周'] * 100 / obj[w]['第' + i + '周']).toFixed(2) + '%';
        }
        o['amount'] = (o['amount'] * 100 / obj[w]['amount']).toFixed(2) + '%';
      }
      for (let i = 1; i<= 8; i ++) {
        // obj[w]['第' + i + '周'] = obj[w]['第' + i + '周'] == 0 ? '' :(obj[w]['第' + i + '周']*100/obj_amount['第' + i + '周']).toFixed(2) + '%';
        obj[w]['第' + i + '周'] = '';
      }
      obj[w]['amount'] = (obj[w]['amount']*100/amount).toFixed(2) + '%';
      obj[w]['on_sale_data'] = Object.values(on_sale_obj[w]);
    }
    onSaleData.value = Object.values(obj);
    loading.value = false;
  });
}

// 选择指标动作
const changeTable = (index, field) => {
  chartData.value[index] = [];
  let obj = {};
  for (let d of tableData.value) {
    if (!obj[d['on_sale_ww']]) obj[d['on_sale_ww']] = {
      'on_sale_ww': d['on_sale_ww'],
      '第1周': '',
      '第2周': '',
      '第3周': '',
      '第4周': '',
      '第5周': '',
      '第6周': '',
      '第7周': '',
      '第8周': '',
      'amount': '',
    };
    obj[d['on_sale_ww']][d['on_shelf_ww']] = renderThousands(d[field]);
    if (isNaN(d[field])) {
      let n1 = Number(obj[d['on_sale_ww']]['amount'].replace('%', ''));
      let n2 = Number(d[field].replace('%', ''));
      obj[d['on_sale_ww']]['amount'] = (n1 + n2).toFixed(2) + '%';
    } else {
      obj[d['on_sale_ww']]['amount'] = Number(obj[d['on_sale_ww']]['amount']) + Number(d[field]);
    }
  }
  for (let k in obj) {
    if (!isNaN(obj[k]['amount'])) {
      if ((obj[k]['amount'] + '').indexOf('.') > -1) obj[k]['amount'] = obj[k]['amount'].toFixed(2);
      obj[k]['amount'] = renderThousands(obj[k]['amount']);
    }
  }
  chartData.value[index] = Object.values(obj);
}

const getSummaries = (param) => {
  const { columns, data } = param;  // 所有列的属性，所有行数据值
  const sums = [] as any;
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '总计';
      return;
    }
    const values = data.map(item => item[column.property].replaceAll(',', ''));  // 取出一列值
    if (values.every(value => value == '')) {
      sums[index] = '';
    } else if (!values.every(value => isNaN(value) || value == '')) {  // 判断该列中的值是否全是数字
      sums[index] = values.reduce((amt, item) => {  // 累加器，该列值累加计算
        const value = Number(item);
        if (!isNaN(value) && value > 0) {
          return amt + value;
        } else {
          return amt;
        }
      }, 0);
      sums[index] = renderThousands((sums[index] + '').indexOf('.') > -1 ? sums[index].toFixed(2) : sums[index]);
    } else {  // 有百分号的情况
      sums[index] = values.reduce((amt, item) => {
        const value1 = Number((amt + '').replace('%', ''));
        const value2 = Number((item + '').replace('%', ''));
        if (!isNaN(value2) && value2 > 0) {
          return (value1 + value2).toFixed(2);
        } else {
          return value1;
        }
      }, '');
      sums[index] += '%';
    }
  });

  return sums;
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Filter, {
      onSearchAction: searchAction,
      weeklyEnable: false
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showIndicator.value, (k, i) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: k,
        class: "card mb-5 mb-xl-10"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_select, {
              modelValue: showIndicator.value[i],
              "onUpdate:modelValue": ($event: any) => ((showIndicator.value[i]) = $event),
              size: "small",
              placeholder: "请选择指标",
              onChange: ($event: any) => (changeTable(i, showIndicator.value[i])),
              style: {"width":"180px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicator.value, (v) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    value: v['field'],
                    key: v['field'],
                    label: v['name']
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_table, {
                data: chartData.value[i],
                "show-summary": true,
                "summary-method": getSummaries
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "on_sale_ww",
                    label: "上新周",
                    align: "center",
                    width: "165"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "第1周",
                    label: "第1周",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "第2周",
                    label: "第2周",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "第3周",
                    label: "第3周",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "第4周",
                    label: "第4周",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "第5周",
                    label: "第5周",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "第6周",
                    label: "第6周",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "第7周",
                    label: "第7周",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "第8周",
                    label: "第8周",
                    align: "center"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "amount",
                    label: "总计",
                    align: "center"
                  })
                ]),
                _: 2
              }, 1032, ["data"])
            ])
          ])
        ])
      ])), [
        [_directive_loading, loading.value]
      ])
    }), 128)),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              id: "on_sale_table",
              data: onSaleData.value,
              "default-expand-all": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { type: "expand" }, {
                  default: _withCtx((props) => [
                    _createVNode(_component_el_table, {
                      data: props.row.on_sale_data,
                      border: false,
                      "show-header": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "goods_sale_type",
                          label: "销售类型",
                          align: "center",
                          width: "200"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "第1周",
                          label: "第1周",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "第2周",
                          label: "第2周",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "第3周",
                          label: "第3周",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "第4周",
                          label: "第4周",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "第5周",
                          label: "第5周",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "第6周",
                          label: "第6周",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "第7周",
                          label: "第7周",
                          align: "center"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "第8周",
                          label: "第8周",
                          align: "center"
                        })
                      ]),
                      _: 2
                    }, 1032, ["data"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "on_sale_ww",
                  label: "上新周",
                  align: "center",
                  width: "155"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "第1周",
                  label: "第1周",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "第2周",
                  label: "第2周",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "第3周",
                  label: "第3周",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "第4周",
                  label: "第4周",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "第5周",
                  label: "第5周",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "第6周",
                  label: "第6周",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "第7周",
                  label: "第7周",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "第8周",
                  label: "第8周",
                  align: "center"
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, loading.value]
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Detail, {
      filters: _unref(filters),
      title: "明细数据",
      apiUrl: apiUrl,
      reportId: 3,
      loading: loading.value
    }, null, 8, ["filters", "loading"])
  ], 64))
}
}

})